import { render, staticRenderFns } from "./emailregister.vue?vue&type=template&id=a35eab16&scoped=true"
import script from "./emailregister.vue?vue&type=script&lang=js"
export * from "./emailregister.vue?vue&type=script&lang=js"
import style0 from "./emailregister.vue?vue&type=style&index=0&id=a35eab16&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35eab16",
  null
  
)

export default component.exports